import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {Button, Form, FormControl, Spinner, Table} from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//hooks
import useRematchDispatch from "../../hooks/useRematchDispatch";

//services
import Colors from "../../utils/Colors";
import {useTranslation} from "react-i18next";

const ModelScreen = () => {
    const {t} = useTranslation();
    const {CreateModel, LoadModels, LoadBrands} = useRematchDispatch(dispatch => ({
        CreateModel: dispatch.car.CreateModel,
        LoadModels: dispatch.car.LoadModels,
        LoadBrands: dispatch.car.LoadBrands,
    }));
    const processing = useSelector(state => state.main.processing);
    const models = useSelector(state => state.car.models);
    const brands = useSelector(state => state.car.brands);
    const [inputs, setInputs] = useState({
        name: '',
        id: null,
    });

    const [errors, setErrors] = useState({
        name: false,
    });
    const [selectedId, setSelectedId] = useState();
    const [brandId, setBrandId] = useState();

    useEffect(() => {
        LoadBrands();

    }, []);

    useEffect(() => {
        const selected = models.find(x => x.id === selectedId);

        if (selected !== undefined) {
            setInputs(selected)
        }
    }, [selectedId]);

    useEffect(() => {
        if (brandId) {
            LoadModels(brandId);
        }
    }, [brandId]);


    const handleClick = () => {
        if (inputs.name.length === 0) {
            setErrors(errs => ({...errs, "name": true}));
            return;
        } else {
            setErrors(errs => ({...errs, "name": false}));
        }
        if (inputs.longitude === 0) {
            setErrors(errs => ({...errs, "longitude": true}));
            return;
        } else {
            setErrors(errs => ({...errs, "longitude": false}));
        }
        if (inputs.latitude === 0) {
            setErrors(errs => ({...errs, "latitude": true}));
            return;
        } else {
            setErrors(errs => ({...errs, "latitude": false}));
        }
        inputs.brandId = brandId;
        CreateModel(inputs);
    };

    const handleNewClick = () => {
        let empty = {};
        for (const input in inputs) {
            let value = "";
            if (input === 'longitude' || input === 'latitude') {
                value = 0;
            }
            empty[input] = value;
        }
        setInputs(empty);
        setSelectedId("");
    };

    const inputStyle = {
        marginBottom: 10
    };

    const onPropertyValueChange = (event) => {
        const value = event.target.value;
        setInputs({...inputs, [event.target.id]: value.toUpperCase()});

    };

    const renderBrands = () => {
        return (
            <main className="card">
                <div className="card-header">
                    {t('brands')}
                </div>
                <div className="card-body">
                    {brands.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1).map(x =>
                        <Button style={{margin: 5}} key={x.id}
                                variant={`${x.id === brandId ? "info" : ""}`}
                                onClick={() => setBrandId(x.id)}
                        >
                            {x.name.toUpperCase()}
                        </Button>
                    )}
                </div>
            </main>
        )
    };

    const renderModels = () => {
        return (
            <Table bordered hover>
                <thead>
                <tr className="text-center" bgcolor={Colors.greyhish}>
                    <th>{t('name')}</th>
                </tr>
                </thead>
                <tbody>
                {models.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1).map((x) =>
                    <tr key={x.id} bgcolor={x.id === selectedId ? Colors.defaultBackground : Colors.white}
                        onClick={() => {
                            setSelectedId(x.id)
                        }} style={{cursor: 'pointer'}}>
                        <td>{x.name}</td>
                    </tr>)}
                </tbody>
            </Table>
        )
    };

    return (
        <main>
            <div>{renderBrands()}</div>
            <div className="container w-50">
                <span className="space"/>
                <div className="justify-content-center">
                    <Form.Group as={Row}>
                        <Form.Label column sm={3}> {t('name')}   </Form.Label>
                        <Col sm={9}><FormControl id="name" type="text" placeholder={t('name')} className="mr-sm-2"
                                                 style={inputStyle} isInvalid={errors.name}
                                                 onChange={(event) => onPropertyValueChange(event)}
                                                 value={inputs.name}
                        />
                        </Col>
                    </Form.Group>

                    <div className="text-center">

                        <Button variant="outline-dark" style={{marginRight: 10, backgroundColor: Colors.greyhish}}
                                onClick={() => {
                                    handleNewClick()
                                }}>{t('new')}</Button>

                        <Button variant="outline-dark" onClick={() => {
                            handleClick()
                        }} disabled={!brandId}> {processing ?
                            <Spinner as="span" animation="grow" size="sm" role="status"
                                     aria-hidden="true"/> : null}{t('validate')}</Button>
                    </div>
                </div>
                <span className="space"/>
                <div>{renderModels()}</div>
            </div>
        </main>
    );
};

export default ModelScreen
